let GO1_API = "";
let environment = "local";

if (window && window.authConfig) {
    environment = window.authConfig.environment || "local";
    GO1_API = `${window.authConfig.gateway_url}/` || "https://api.go1.co/";
}

if (environment === "local") {
    GO1_API = "http://localhost/GO1/";
}

export default GO1_API;



// WEBPACK FOOTER //
// ./src/config/api.js